/** Deployment-specific branding for the coach character — generated by
 *  sales-academy-factory from the spec's coach.name_placeholder. The framework
 *  refers to the coach generically as "coach" everywhere; this is the one place
 *  the human-visible name lives. */
export const COACH = {
  fullName: 'Jordan',
  firstName: 'Jordan',
  title: 'Coach Jordan',
} as const;
